import { withStyles, TableCell } from '@material-ui/core';

const StyledTableHeaderCell = withStyles((theme) => ({
  root: {
    padding: '6px',
    height: 'auto',
  },
  head: {
    border: `1px solid ${theme.printTableBorder}`
  },
  body: {
    fontSize: theme.textFontSize,
    border: `1px solid ${theme.printTableBorder}`,
  }
}))(({ style, ...props }) => (
  <TableCell style={{ ...style }} {...props} />
));

export default StyledTableHeaderCell;
